import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DrawerLayoutWrapper } from 'common';
import ProgressBar from 'feature/dispatching/components/ProgressBar';
import TrailersForm from '../components/TrailersForm';
import { useGetNewTrailersForLocationQuery } from '../../trailerStatusEndpoints';

const lens = R.lensProp('trailers');

const Trailers = ({ onClose, next, trailerState, setTrailerState }) => {
  const { trailers } = trailerState;
  const { viewById } = useParams();

  const params = { locationId: viewById };
  const { data = [], isLoading } = useGetNewTrailersForLocationQuery({ params });

  const isInvalid = R.o(R.gt(1), R.path(['trailers', 'length']))(trailerState);

  const handleAdd = trailerId => {
    const over = R.append(trailerId);
    setTrailerState(R.over(lens, over));
  };

  const handleRemove = trailerId => {
    const over = R.reject(R.equals(trailerId));
    setTrailerState(R.over(lens, over));
  };

  const buttons = (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', width: 1 }}>
      <Button disabled={isInvalid} onClick={next} sx={{ width: 150 }}>
        Submit
      </Button>
    </Box>
  );

  return (
    <DrawerLayoutWrapper
      buttons={buttons}
      headerButtonText="CLOSE"
      isLoading={isLoading}
      onHeaderButtonClick={onClose}
      title="Add Trailer"
    >
      <ProgressBar
        label="Trailers (1 of 2)"
        sx={{
          '&.MuiLinearProgress-colorPrimary > .MuiLinearProgress-bar': {
            borderRadius: '10px',
          },
        }}
        value={50}
      />
      <Stack sx={{ mt: 3, width: 390 }}>
        <TrailersForm
          onAdd={handleAdd}
          onRemove={handleRemove}
          selectableTrailers={data}
          trailers={trailers}
        />
      </Stack>
    </DrawerLayoutWrapper>
  );
};

Trailers.propTypes = {
  next: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  setTrailerState: PropTypes.func.isRequired,
  trailerState: PropTypes.shape({
    trailers: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default Trailers;
